// extracted by mini-css-extract-plugin
export var gif = "_jl-0";